<ng-content></ng-content>
{{ value }}
